import { Injectable } from '@angular/core';
import { ApiService, IApiOption } from '@red/api';
import { PaginationAdapter } from '@red/data-access';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { plainToInstance } from 'class-transformer';
import { ReminderDeliveryModel } from '@shared/data-access/models/payment-reminder.model';

@Injectable({
  providedIn: 'root',
})
export class PaymentReminderDeliveryApiService {
  static ROOT_POINT = 'storage/payment-reminder-infos';

  constructor(private _apiService: ApiService) { }

  search(query = {}, option?: IApiOption): Observable<PaginationAdapter<ReminderDeliveryModel>> {
    return this._apiService.get(PaymentReminderDeliveryApiService.ROOT_POINT, query, option).pipe(map(data => new PaginationAdapter(ReminderDeliveryModel, data)));
  }

  get(id: number): Observable<ReminderDeliveryModel> {
    return this._apiService.get(PaymentReminderDeliveryApiService.ROOT_POINT + '/' + id).pipe(map(res => plainToInstance(ReminderDeliveryModel, res) as ReminderDeliveryModel));
  }

  getAttachment(data: { id: number }) {
    return this._apiService.get(`${PaymentReminderDeliveryApiService.ROOT_POINT}/:id/attachment`, data, {
      pretreatmentResponse: false,
      requestOptions: { responseType: 'arraybuffer' },
    });
  }


  resend(id: number): Observable<any> {
    return this._apiService.post(`${PaymentReminderDeliveryApiService.ROOT_POINT}/${id}/resend`, {});
  }

}
